import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import * as moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { AiOutlineSearch, AiOutlineEdit } from "react-icons/ai";
import axioPath from '../../../../../api/axioPath';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Spinner from '../../../../components/Spinner'
import { appUserList, adminUserList, setUserInfoDetails } from '../../../../../redux/actions/admin';
import { SearchWrapper } from '../DashBoard/dashBoardStyled'
import { Heading, TableWrapper } from 'web/pages/private/Admin/adminStyled'
import { stateConvert } from 'web/components/utils/stateAbbreviation';
import { Table } from 'reactstrap';
import Pagination from '@material-ui/lab/Pagination';
import Typography from '@material-ui/core/Typography';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import styled from 'styled-components';

import ExportModal from './ExportModal'
import AddAdminModal from './AddAdminModal'
import EditAdminModal from './EditAdminModal'
import AddLimitModal from './AddLimitModal'
import PurchaseLimitModal from './PurchaseLimitModal'

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const buttonStyle = { background: '#61b01f', background: 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', cursor: 'pointer' }
const disabledButtonStyle = { background: '#61b01f', background: 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', opacity: '0.5' }

function Users() {
  const dispatch = useDispatch();
  let history = useHistory()
  let location = useLocation();
  const [value, setValue] = useState(0);
  const userManagemntCustomerDetails = useSelector(state => state.admin.userManagemntCustomerDetails)
  const userManagemntAdminDetails = useSelector(state => state.admin.userManagemntAdminDetails)
  const [modal, setModal] = useState(false);
  const adminRoles = useSelector(state => state.admin.adminRoles)
  const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
  const [addInnerCircleModal, setAddInnerCircleModal] = useState(false);
  const [removeInnerCircleModal, setRemoveInnerCircleModal] = useState(false);
  const [addAdminModal, setAddAdminModal] = useState(false)
  const [editAdminModal, setEditAdminModal] = useState(false)
  const [addLimitModal, setAddLimitModal] = useState(false)
  const [purchaseLimitModal, setPurchaseLimitModal] = useState(false)
  const [modalMessage, setModalMessaage] = useState('')
  const [dataList, setDataList] = useState([])
  const [finalData, setFinalData] = useState([])
  const [finalexportData, setfinalexportData] = useState([])
  const [adminDataList, setAdminDataList] = useState([])
  const [adminFinalData, setAdminFinalData] = useState([])
  const [tableSearch, setTableSearch] = useState('')
  const [searchDataList, setSearchDataList] = useState([]);
  const [searchAdminDataList, setSearchAdminDataList] = useState([]);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [adminPage, setAdminPage] = useState(1);
  const [adminPageCount, setAdminPageCount] = useState(0);
  const loggedInAuthId = localStorage.getItem('adminAuthId')
  const [pageLoader, setPageLoader] = useState(false)

  //for export
  const [exportModal, setExportModal] = useState(false)
  const token = localStorage.getItem("token")

  useEffect(() => {
    let userRole = localStorage.getItem('accountType')
    let appUserRolesList = ['Both', 'Buyer', 'Seller']
    if (userRole !== 'Admin') {
      if (appUserRolesList.includes(userRole)) history.push('/dashboard')
      else history.push('/sign-in')
      window.location.reload();
    }
    if (location?.state?.noteUpdated) {
      setPageLoader(true)
      fetchMyAPI();
    } else if (location.state !== null && location.state !== undefined) {
      // set customer details from redux
      let currentPageNumber = page
      if (location.state.pageNumber) {
        currentPageNumber = location.state.pageNumber
        setPage(currentPageNumber)
      }
      let userDataList = userManagemntCustomerDetails.filter(val => val.authId !== null)
      let pageData = JSON.parse(JSON.stringify(userDataList.reverse()))
      setfinalexportData(pageData)
      setDataList(userDataList)
      setSearchDataList(userDataList)

      setFinalData(pageData.splice(currentPageNumber * 10 - 10, 10))
      if (userDataList.length % 10 === 0) {
        setPageCount(userDataList.length / 10)
      } else {
        setPageCount(Math.trunc(userDataList.length / 10) + 1)
      }
      setTableSearch('')

      // set admin details from redux
      let adminUserDataList = userManagemntAdminDetails.filter(val => val.userId !== loggedInAuthId)
      let pageDataAdmin = JSON.parse(JSON.stringify(adminUserDataList))
      setAdminDataList(adminUserDataList)
      setSearchAdminDataList(adminUserDataList)
      setAdminFinalData(pageDataAdmin.splice(adminPage * 10 - 10, 10))
      if (adminUserDataList.length % 10 === 0) {
        setAdminPageCount(adminUserDataList.length / 10)
      } else {
        setAdminPageCount(Math.trunc(adminUserDataList.length / 10) + 1)
      }
      setTableSearch('')
    } else {
      setPageLoader(true)
      fetchMyAPI();
    }
  }, []);

  //change tab index
  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };

  const fetchMyAPI = async () => {
    let response = '';
    if (!pageLoader) setPageLoader(true)
    response = await dispatch(appUserList());
    if (response) {
      if (response?.newUserRequest) {
        let adminUserDataList = response.newUserRequest.filter(val => val.authId !== null).map(data => {
          return {
            ...data,
            userCheckBox: false
          }
        })
        let pageData = JSON.parse(JSON.stringify(adminUserDataList.reverse()))

        setfinalexportData(JSON.parse(JSON.stringify(adminUserDataList)))
        setDataList(adminUserDataList)
        setSearchDataList(adminUserDataList)

        setFinalData(pageData.splice(page * 10 - 10, 10))
        if (adminUserDataList.length % 10 === 0) {
          setPageCount(adminUserDataList.length / 10)
        } else {
          setPageCount(Math.trunc(adminUserDataList.length / 10) + 1)
        }
        setTableSearch('')
      }
      fetchMyAdminAPI();
    } else {
      setPageLoader(false)
      if (response.statusCode === 401) {
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalMessaage(response.message)
        setModal(!modal)
      }
    }
  };

  const fetchMyAdminAPI = async () => {
    let response = '';
    response = await dispatch(adminUserList());
    setPageLoader(false)
    if (response.status === 200) {
      if (response.data.length && response.data.length !== 0) {
        let adminUserDataListTemp = response.data
        let adminUserDataList = adminUserDataListTemp.filter(val => val.userId !== loggedInAuthId)
        let pageData = JSON.parse(JSON.stringify(adminUserDataList))
        setAdminDataList(adminUserDataList)
        setSearchAdminDataList(adminUserDataList)
        setAdminFinalData(pageData.splice(adminPage * 10 - 10, 10))
        if (adminUserDataList.length % 10 === 0) {
          setAdminPageCount(adminUserDataList.length / 10)
        } else {
          setAdminPageCount(Math.trunc(adminUserDataList.length / 10) + 1)
        }
        setTableSearch('')
      } else if (response.statusCode === 401) {
        history.push('/sign-in')
        window.location.reload(false);
      }
    }
  };

  //handle page change in users
  const handleChange = (event, value) => {
    setPage(value);
    let dataListtemp = JSON.parse(JSON.stringify(searchDataList))
    let pageData = JSON.parse(JSON.stringify(dataListtemp))
    setfinalexportData(JSON.parse(JSON.stringify(dataListtemp)))
    setFinalData(pageData.splice(value * 10 - 10, 10))
  };

  //handle page change in admins
  const handleAdminChange = (event, value) => {
    setAdminPage(value);
    const search = tableSearch
    let dataListtemp = adminDataList.filter(value => {
      return (
        (value.userId !== null && value.userId.toString().toLowerCase().includes(search.toLowerCase())) ||
        (value.name !== null && value.name.toString().toLowerCase().includes(search.toLowerCase())) ||
        (value.email !== null && value.email.toString().toLowerCase().includes(search.toLowerCase())))
    }
    );
    let pageData = JSON.parse(JSON.stringify(dataListtemp))
    setAdminFinalData(pageData.splice(value * 10 - 10, 10))
  };


  const handleAdminStatusChange = (e, index) => {
    e.preventDefault()
    axioPath.post('/users/update/userstatus', {}, {
      headers: {
        email: adminFinalData[index].email,
        status: !adminFinalData[index].status,
        Authorization: token,
      },
    }).then((response) => {
      setModal(!modal)
      setModalMessaage(response.data.message)
    }).catch((ex) => {
    });
  }

  const handleToggle = () => {
    setModal(!modal);
    fetchMyAPI();
  }

  const handleIdClick = (e, index, items) => {
    e.preventDefault()
    axioPath.get(`/users/dalancey-approvedData/${finalData[index].authId}`, {
      headers: {
        Authorization: token,
      },
    }).then((response) => {
      let userDetailsTemp = response?.data

      let userTypeTemp
      if (userDetailsTemp?.buyer) userTypeTemp = 'Buyer'
      if (userDetailsTemp?.seller) userTypeTemp = 'Seller'
      if (userDetailsTemp?.buyer && userDetailsTemp?.seller) userTypeTemp = 'Buyer & Seller'
      let userInfoObject = {
        authId: userDetailsTemp?.authId,
        userName: userDetailsTemp?.name,
        companyName: userDetailsTemp?.companyName,
        dbaName: userDetailsTemp?.dba || 'NA',
        email: userDetailsTemp?.email,
        location: `${userDetailsTemp?.city}, ${stateConvert(userDetailsTemp?.state)}, ${userDetailsTemp?.zip}`,
        phoneNumber: userDetailsTemp?.phoneNumber,
        accountType: userDetailsTemp?.accountType,
        parentCompany: '',
        userType: userTypeTemp,
        licenseNumber: userDetailsTemp?.licenseNumber,
        dnsNumber: userDetailsTemp?.dnbDuns,
        taxId: userDetailsTemp?.taxId ? userDetailsTemp?.taxId : 'NA',
        webUrl: userDetailsTemp?.businessURL,
        description: userDetailsTemp?.businessDesc,
        paymentType: userDetailsTemp?.paymentType,
        buyingPaymentMethod: userDetailsTemp?.buyingPaymentMethod,
        limitAssigned: userDetailsTemp?.paymentAssignedLimit,
        sellerAccountInfo: '',
        broker: userDetailsTemp?.isReseller,
        paymentDetails: userDetailsTemp?.paymentDetails,
        promoCode: userDetailsTemp?.promoCodes,
        referralCode: userDetailsTemp?.referralCode,
        successfullInvites: userDetailsTemp?.successfullInvites,
        referralDiscountAvailed: userDetailsTemp?.referralDiscountAvailed,
        referralDescription: userDetailsTemp?.ownerDescription,
        licenseImage: userDetailsTemp?.uploadImage,
        notes: userDetailsTemp?.note,
        diverseTrackingResponse: userDetailsTemp?.diverseTrackingResponse,
        isPlalletSupplier: userDetailsTemp?.isPalletSupplier
      }
      dispatch(setUserInfoDetails(userInfoObject))
      history.push({
        pathname: '/detailedUserInfo',
        state: { page: 'userManagement', currentPage: page, items: userDetailsTemp }
      })

    }).catch((ex) => {
      setModal(!modal)
      setModalMessaage(ex.message || ex?.data?.message || 'Something went wrong, please try again.')
    });

  }

  const handleSearchChange = e => {
    e.preventDefault()
    setTableSearch(e.target.value)
    const search = e.target.value
    //users
    let dataListtemp = dataList.filter(value => {


      return (
        (value?.name?.toString().toLowerCase().includes(search.toLowerCase())) ||
        (value?.email?.toString().toLowerCase().includes(search.toLowerCase())) ||
        (value?.companyName?.toString().toLowerCase().includes(search.toLowerCase())) ||
        (value?.city?.toString().toLowerCase().includes(search.toLowerCase())) ||
        (stateConvert(value?.state)?.toString().toLowerCase().includes(search.toLowerCase())) ||
        (value?.acknowledgedName?.toString().toLowerCase().includes(search.toLowerCase())) ||
        (value?.acknowledgedCreateTime > 0 && moment((new Date(value.acknowledgedCreateTime * 1000).toISOString()), 'YYYY-MM-DD').format('MM/DD/YYYY')?.toString().toLowerCase().includes(search.toLowerCase()))
      )
    }
    );
    setPage(1)
    if (dataListtemp.length % 10 === 0) {
      setPageCount(dataListtemp.length / 10)
    } else {
      setPageCount(Math.trunc(dataListtemp.length / 10) + 1)
    }

    let tempSearchData = JSON.parse(JSON.stringify(dataListtemp))
    // setDataList(tempSearchData)
    setSearchDataList(tempSearchData)
    setfinalexportData(tempSearchData)
    setFinalData(dataListtemp.splice(0, 10))

    //admins
    let dataAdminListtemp = adminDataList.filter(value => {
      return (
        (value.userId !== null && value.userId.toString().toLowerCase().includes(search.toLowerCase())) ||
        (value.name !== null && value.name.toString().toLowerCase().includes(search.toLowerCase())) ||
        (value.email !== null && value.email.toString().toLowerCase().includes(search.toLowerCase()))
      )
    }
    );
    setAdminPage(1)
    if (dataAdminListtemp.length % 10 === 0) {
      setAdminPageCount(dataAdminListtemp.length / 10)
    } else {
      setAdminPageCount(Math.trunc(dataAdminListtemp.length / 10) + 1)
    }
    setSearchAdminDataList(dataAdminListtemp)
    setAdminFinalData(dataAdminListtemp.splice(0, 10))
  }

  const handleConfirmationToggle = () => {
    setDeleteConfirmationModal(!deleteConfirmationModal);
    axioPath.post('/users/delete', {
      email: localStorage.getItem('NewApprovalDeleteEmail')
    }, {
      headers: {
        Authorization: token,
      },
    }
    ).then((response) => {
      setModal(!modal)
      setModalMessaage('User request has been deleted.')
    }).catch((ex) => {
    });
  }

  let headerArr = [
    { title: 'User Name', },
    { title: 'Email ID', },
    { title: 'Company Name', },
    { title: 'City', },
    { title: 'State', },
    { title: 'Zip', },
    { title: 'Account Type', },
    { title: 'Broker', },
    { title: `FC Member`, },
    { title: 'Heard From', },
    { title: `Acknowledged Version`, },
    { title: 'Acknowledged Name ', },
    { title: 'Acknowledged Date', },
  ];

  let adminHeaderArr = [
    { title: 'ID', },
    { title: 'User Name', },
    { title: 'Email ID', },
    { title: 'Admin Roles', },
    { title: 'Status', },
    { title: 'Actions', }
  ];

  const checkStyle = {
    appearance: 'auto',
    marginRight: '5px',
    paddingTop: '24px',
    height: '15px',
    width: '15px',
    position: 'relative',
    top: '2px',
  }

  const closeExportModal = values => {
    setExportModal(false)
  }

  const closeAdminModal = values => {
    const token = localStorage.getItem("token")
    const roles = values.access.map(data => data.value)
    let url = `/access/${values.email}/${roles}`
    axioPath.get(url, {
      headers: {
        Authorization: token,
        token: token
      },
    }).then((response) => {
      setAddAdminModal(false)
      setModalMessaage(response.data.message)
      setModal(!modal)
    }).catch((ex) => {
      setAddAdminModal(false)
    });
  }

  const closeEditAdminModal = values => {
    const token = localStorage.getItem("token")
    const roles = values.access.map(data => data.value)
    // let url = `update-roles/${values.email}/${roles}`
    let url = "update-roles"

    let data = {
      email: values.email,
      roleId: roles
    }
    axioPath.post(url, data, {
      headers: {
        Authorization: token
      },
    }).then((response) => {
      setEditAdminModal(false)
      setModalMessaage(response.data.message)
      setModal(!modal)
      fetchMyAdminAPI();
    }).catch((ex) => {
      setEditAdminModal(false)
    });
  }

  const closeAddLimitModal = values => {
    const token = localStorage.getItem("token")
    const id = localStorage.getItem("UserThresholdLimit")
    const limit = values.amount
    let url = `user/location/reset/purchasing/limit/superadmin/${id}`
    axioPath.post(url, {
      amount: limit
    }, {
      headers: {
        Authorization: token
      },
    }).then((response) => {
      setAddLimitModal(false)
      if (response.data.message) setModalMessaage(response.data.message)
      else setModalMessaage("Process failed, try again")
      setModal(!modal)
    }).catch((ex) => {
      setAddLimitModal(false)
    });
  }

  const closePurchaseLimitModal = values => {
    const token = localStorage.getItem("token")
    const id = localStorage.getItem("UserPurchaseLimit")
    const limit = values.purchaseLimit
    let url = `user/location/edit/purchasing/limit/superadmin/${id}`
    axioPath.post(url, {
      amount: limit
    }, {
      headers: {
        Authorization: token
      },
    }).then((response) => {
      setPurchaseLimitModal(false)
      if (response.data.message) setModalMessaage(response.data.message)
      else setModalMessaage("Process failed, try again")
      setModal(!modal)
    }).catch((ex) => {
      setPurchaseLimitModal(false)
    });
  }

  const handleCheck = (event, index) => {
    let tempData = JSON.parse(JSON.stringify(dataList))
    let tempSearchData = JSON.parse(JSON.stringify(searchDataList))
    tempSearchData[(page * 10 - 10) + index].userCheckBox = !tempSearchData[(page * 10 - 10) + index].userCheckBox
    tempSearchData = tempSearchData.map(data => ({ ...data }))
    let indexVal = tempData.findIndex(val => val.authId === tempSearchData[(page * 10 - 10) + index].authId);
    tempData[indexVal].userCheckBox = !tempData[indexVal].userCheckBox
    tempData = tempData.map(data => ({ ...data }))
    let tempDataList = JSON.parse(JSON.stringify(tempData))
    let tempDataSearchList = JSON.parse(JSON.stringify(tempSearchData))
    setDataList(tempDataList)
    setSearchDataList(tempDataSearchList)
    setfinalexportData(tempSearchData)
    setFinalData(tempSearchData.splice(page * 10 - 10, 10))
  }

  const handleInnerCircleApi = () => {
    let innerCircleStatus = addInnerCircleModal ? true : false
    setPageLoader(true)
    let usersList = dataList.filter(val => val.userCheckBox === true).map(val => val.authId)
    let data = { authIds: usersList }
    let token = localStorage.getItem('token')
    axioPath.post('users/update/innerCircle', data, {
      headers: {
        Authorization: token,
        status: innerCircleStatus
      },
    }).then((response) => {
      if (response.data.status === 'SUCCESS') {
        setPageLoader(false)
        setModalMessaage(response.data.message)
        setModal(!modal)
      } else {
        setPageLoader(false)
        if (response.message === "Unauthorized (Invalid token)") {
          history.push('/sign-in')
        } else {
          setModalMessaage(response.message)
          setModal(!modal)
        }
      }
      setAddInnerCircleModal(false)
      setRemoveInnerCircleModal(false)
    }).catch((ex) => {
      setPageLoader(false)
      setModalMessaage(ex.message)
      setModal(!modal)
      setAddInnerCircleModal(false)
      setRemoveInnerCircleModal(false)
    });
  }

  return (
    <>
      {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('USER_MANAGEMENT'))) ?
        <Container>
          <TableWrapper>
            {pageLoader && <Spinner />}
            <Heading>
              <h3>USER MANAGEMENT</h3>

              <div className='d-flex flex-wrap flex-sm-nowrap'>
                <SearchWrapper>
                  <input type="text" placeholder='Search' value={tableSearch}
                    onChange={handleSearchChange} />
                  <AiOutlineSearch />
                </SearchWrapper>
                {value === 1 ?
                  <button
                    style={buttonStyle}
                    onClick={e => setAddAdminModal(true)}
                  >
                    Add Admin
                  </button>
                  :
                  <>
                    <button
                      style={((searchDataList && searchDataList.filter(val => val.userCheckBox === true).length === 0) && (dataList && dataList.filter(val => val.userCheckBox === true).length === 0)) ? disabledButtonStyle : buttonStyle}
                      disabled={(searchDataList && searchDataList.filter(val => val.userCheckBox === true).length === 0) && (dataList && dataList.filter(val => val.userCheckBox === true).length === 0)}
                      onClick={e => setAddInnerCircleModal(true)}
                    >
                      Add to Founders Circle
                    </button>
                    <button
                      style={((searchDataList && searchDataList.filter(val => val.userCheckBox === true).length === 0) && (dataList && dataList.filter(val => val.userCheckBox === true).length === 0)) ? disabledButtonStyle : buttonStyle}
                      disabled={(searchDataList && searchDataList.filter(val => val.userCheckBox === true).length === 0) && (dataList && dataList.filter(val => val.userCheckBox === true).length === 0)}
                      onClick={e => setRemoveInnerCircleModal(true)}
                    >
                      Remove from Founders Circle
                    </button>
                    <button
                      style={{ background: '#27911b', color: 'white', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '5px' }}
                      onClick={() => setExportModal(true)}>
                      Export
                    </button>
                  </>
                }
              </div>
            </Heading>

            <AppBar position="static">
              <Tabs value={value} onChange={handleChangeTab} aria-label="simple tabs example">
                <Tab label="Applications User" {...a11yProps(0)} />
                <Tab label="Admins" {...a11yProps(1)} />
              </Tabs>
            </AppBar>

            <TabPanel value={value} index={0}>

              <Table responsive>
                <thead>
                  <tr>
                    {headerArr.map((items, index) => (
                      <th key={index}>{items.title}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {
                    finalData.map((items, index) => (
                      <tr key={index}>
                        <td>
                          <input style={checkStyle} type="checkbox" checked={items.userCheckBox} onChange={(event) => handleCheck(event, index)} />
                          <a style={{ color: '#00b2fe', cursor: 'pointer' }}
                            onClick={e => handleIdClick(e, index, items)}
                          >{items.name}</a>
                        </td>
                        <td>{items.email}</td>
                        <td>{items.companyName}</td>
                        <td>{items.city?.trim()}</td>
                        <td>{stateConvert(items.state)}</td>
                        <td>{items.zip}</td>
                        <td>
                          {items.accountType === 'USER_GUEST' ? 'Guest' :
                            (items.buyer && items.seller) ? 'Both' :
                              items.buyer ? 'Buyer' :
                                items.seller ? 'Seller' : 'NA'}
                        </td>
                        <td>{items.reseller ? 'Yes' : 'No'}</td>
                        <td>{items.innerCircle ? 'Yes' : 'No'}</td>
                        <td title={items?.hearAbout} style={{ minWidth: '175px' }}>
                          {items?.hearAbout?.substring(0, 50)}
                          {items?.hearAbout?.length > 50 && <span>...</span>}
                        </td>
                        <td>{items.termsAndConditionsVersion}</td>
                        <td>{items.acknowledgedName}</td>
                        <td>{items.termsAndConditionsApplyTime ? moment(items.termsAndConditionsApplyTime).format('MM/DD/YYYY') : ''}</td>
                      </tr>
                    ))}
                </tbody>
              </Table>

              {dataList.length !== 0 && <Pagination count={pageCount}
                page={page}
                onChange={handleChange} />}

            </TabPanel>
            <TabPanel value={value} index={1}>
              <Table responsive>
                <thead>
                  <tr>
                    {adminHeaderArr.map((items, index) => (
                      <th key={index}>{items.title}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {
                    adminFinalData.map((items, index) => (
                      <tr key={index}>
                        <td>{items.userId}
                        </td>
                        <td>{items.name}</td>
                        <td>{items.email}</td>
                        <td style={{ maxWidth: '650px' }}>{items.userRoles.join(', ')}</td>
                        <td>
                          <FormControlLabel
                            style={{ margin: 0 }}
                            labelPlacement="start"
                            label={items.status ? 'Active' : 'Inactive'}
                            control={
                              <Switch
                                checked={items.status}
                                onClick={e => handleAdminStatusChange(e, index)}
                                name="checkedB"
                                color="primary"
                              />
                            }
                          />
                        </td>
                        <td>
                          <AiOutlineEdit
                            title="Edit Admin Roles"
                            onClick={(e) => {
                              setEditAdminModal(true)
                              localStorage.setItem('EditAdminEmail', adminFinalData[index].email)
                              localStorage.setItem('EditAdminRoles', adminFinalData[index].userRoles)
                            }} style={{ margin: '0px 10px 0px 10px', height: '23px', width: '23px', cursor: 'pointer' }} />
                        </td>

                      </tr>
                    ))}
                </tbody>
              </Table>
              {adminDataList.length !== 0 && <Pagination count={adminPageCount}
                page={adminPage}
                onChange={handleAdminChange} />}
            </TabPanel>

            <Modal isOpen={modal}>
              <ModalHeader toggle={handleToggle}><h6>Status</h6></ModalHeader>
              <ModalBody>
                {modalMessage}
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={handleToggle}>OK</Button>
              </ModalFooter>
            </Modal>

            <Modal isOpen={deleteConfirmationModal} centered={true}>
              <ModalHeader toggle={e => {
                setDeleteConfirmationModal(!deleteConfirmationModal)
                localStorage.removeItem('NewApprovalDeleteEmail')
              }}>
                <h6>Delete Confirmation</h6>
              </ModalHeader>
              <ModalBody>
                Do you want to delete this user?
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={handleConfirmationToggle}>Yes</Button>
                <Button color="secondary" onClick={e => {
                  setDeleteConfirmationModal(!deleteConfirmationModal)
                  localStorage.removeItem('NewApprovalDeleteEmail')
                }}>
                  No
                </Button>
              </ModalFooter>
            </Modal>

            <Modal isOpen={exportModal} centered={true}>
              <ModalHeader toggle={() => setExportModal(false)}><h6>Download Report - User Details</h6></ModalHeader>
              <ModalBody>
                <ExportModal onEnter={closeExportModal} dataList={finalexportData} />
              </ModalBody>
            </Modal>

            <Modal isOpen={addAdminModal} centered={true}>
              <ModalHeader toggle={() => setAddAdminModal(false)}><h6>Add Admin Access</h6></ModalHeader>
              <ModalBody>
                <AddAdminModal onEnter={closeAdminModal} />
              </ModalBody>
            </Modal>

            <Modal isOpen={editAdminModal} centered={true}>
              <ModalHeader toggle={() => setEditAdminModal(false)}><h6>Edit Admin Roles</h6></ModalHeader>
              <ModalBody>
                <EditAdminModal onEnter={closeEditAdminModal} />
              </ModalBody>
            </Modal>

            <Modal isOpen={addLimitModal} centered={true}>
              <ModalHeader toggle={() => setAddLimitModal(false)}><h6>Add Threshold Limit</h6></ModalHeader>
              <ModalBody>
                <AddLimitModal onEnter={closeAddLimitModal} />
              </ModalBody>
            </Modal>

            <Modal isOpen={purchaseLimitModal} centered={true}>
              <ModalHeader toggle={() => setPurchaseLimitModal(false)}><h6>Edit Purchase Limit</h6></ModalHeader>
              <ModalBody>
                <PurchaseLimitModal onEnter={closePurchaseLimitModal} />
              </ModalBody>
            </Modal>

            <Modal isOpen={addInnerCircleModal || removeInnerCircleModal} centered={true}>
              <ModalBody>
                {addInnerCircleModal && 'Are you sure that you want to add the selected users to the founders circle?'}
                {removeInnerCircleModal && 'Are you sure that you want to remove the selected users from the founders circle?'}
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={handleInnerCircleApi}>Yes</Button>
                <Button color="secondary" onClick={e => {
                  setAddInnerCircleModal(false)
                  setRemoveInnerCircleModal(false)
                }}>
                  No
                </Button>
              </ModalFooter>
            </Modal>

          </TableWrapper>
        </Container >

        :
        <p>You are not authorized to view this page.</p>
      }
    </>

  )
};

export default Users;

const Container = styled.div`
  
/* .MuiTabs-flexContainer {
 border-bottom: 4px solid #e8e8e8;
} */
`;